import { createCommand } from '../../utils';
import { computeFileHash } from '../computeFileHash';
import { moduleName } from '../state';

export const fileKey = (file: { name: string; size: number }): string => `${file.name}_${file.size}`;

export const CheckDuplicateFilesCommand = createCommand<File[], string[]>(
    `${moduleName}/CHECK_DUPLICATE_FILES`,
    async (files, { extra }) => {
        if (!files || files.length === 0) {
            return [];
        }

        const hashes = await Promise.all(files.map((file) => computeFileHash(file)));

        const duplicateHashList = await extra.externalUpload.checkDuplicates(hashes);
        const duplicateHashSet = new Set(duplicateHashList);

        const duplicateKeys: string[] = [];
        files.forEach((file, index) => {
            const fileHash = hashes[index] ?? '';
            if (duplicateHashSet.has(fileHash)) {
                duplicateKeys.push(fileKey(file));
            }
        });

        return duplicateKeys;
    },
);
